'use strict';

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { ExpirationMaintenance } from '../enum/expirationMaintenance';

/**
 * Dashboard controller
 */
export default [
    '$scope', '$timeout', '$rootScope', '$q', '$utils', '$filterUtils', 'DashboardFiltersService',
    'MilestoneService', 'IndustryService', 'MetricService', 'ChartOptionsService',
    'SpinnerService', 'PrintService', '$window', 'ProjectService',
    (
        $scope, $timeout, $rootScope, $q, $utils, $filterUtils, DashboardFiltersService,
        MilestoneService, IndustryService, MetricService, ChartOptionsService,
        SpinnerService, PrintService, $window, ProjectService,
    ) => {
        $rootScope.title = '';
        $scope.style = {
            top: $window.scrollY - 100 + $window.innerHeight / 2 + "px",
        }
        $scope.statistic = {
            totalItems: 0,
            totalCost: 0,
            totalWplaces: 0,
        };
        $scope.defaultColors = [
            '#DCDCDC', '#ffd8b1', '#FF7F50', '#6495ED', '#e6194b', '#00CED1', '#FFD700', '#97BBCD', '#32CD32', '#FF69B4', '#1E90FF', '#FF4500', '#AAAA11', '#00FA9A', '#00BFFF', '#FF8C00', '#6A5ACD', '#20B2AA', '#FF1493', '#8B0000' 
        ];

        $scope.barColors = ['#6495ED', '#e6194b', '#00CED1', '#FFD700', '#97BBCD', '#32CD32', '#FF69B4', '#1E90FF', '#FF4500', '#AAAA11', '#00FA9A', '#00BFFF', '#FF8C00', '#6A5ACD', '#20B2AA', '#FF1493', '#8B0000']


        $scope.isPrint = false;
        $scope.isPrintPdf = false;
        $scope.printablePages = [];

        function beforePrint () {
            for (const id in Chart.instances) {
              Chart.instances[id].resize()
            }
        }

        function afterPrint () {
            for (const id in Chart.instances) {
              Chart.instances[id].resize()
            }
        }

        if (window.matchMedia) {
            let mediaQueryList = window.matchMedia('print')
            mediaQueryList.addListener(function(mql) {
                if (mql.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
          
        window.onbeforeprint = beforePrint
        window.onafterprint = afterPrint

        $scope.printHTML = function() {
            PrintService.open().result.then(function(data) {
                $scope.printablePages = angular.copy(data);
                $scope.isPrint = true;
                $timeout(() => {
                    window.print();
                    $scope.printablePages = [];
                    $scope.isPrint = false;
                }, 600)
            });
        }

        function getImageCoordsToFitPage(canvas, pdfHeight, pdfWidth, pagePadding, yOffset) {
            let imageRatio = canvas.width / canvas.height;
            let imageHeight = Math.min(canvas.height, (pdfHeight - pagePadding - yOffset));
            let imageWidth = Math.min(imageRatio * imageHeight, pdfWidth - pagePadding * 2);
            return [Math.round(imageWidth), Math.round(imageWidth / imageRatio)];
        }

        $scope.printPDF = function() {
            let pdf = jsPDF({orientation: "landscape", unit: "px" });
            PrintService.open().result.then(function(data) {
                $scope.printablePages = angular.copy(data);
                $scope.isPrint = true;
                $scope.isPrintPdf = true;
                SpinnerService.startLoading();
                
                $timeout(async () => {
                    try {
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const pagePadding = 10;

                        const charts = document.getElementsByClassName('dashboard__chart-row')
                        let dashboardInfo = document.getElementById('dashboard-info')
                        let filtersSize = [];
                        let filterOffset = 0;
                        let filtersCanvas = undefined;
                        if (dashboardInfo) {
                            filtersCanvas = await html2canvas(dashboardInfo, { scale: 2 });
                            filtersSize = getImageCoordsToFitPage(filtersCanvas, pdfHeight, pdfWidth, pagePadding, 10);
                            filterOffset = filtersSize[1] ? filtersSize[1] + 10 : 0;
                        }

                        for (const chart of charts) {
                            if (charts[0] !== chart) pdf.addPage({orientation: "landscape"})
                            const chartImage = await html2canvas(chart, { scale: 2 });
                            const imageSize = getImageCoordsToFitPage(chartImage, pdfHeight, pdfWidth, pagePadding, filterOffset)
                            if (filtersCanvas) {
                                pdf.addImage(filtersCanvas, 'PNG', pagePadding, 10, filtersSize[0], filtersSize[1], undefined, "FAST")
                            }
                            pdf.addImage(chartImage, 'PNG', pagePadding, filterOffset, imageSize[0], imageSize[1], undefined, "FAST");
                        }

                        // const canvases = document.getElementsByTagName('canvas')

                        // let dashboardInfo = document.getElementById('dashboard-info')
                        // let filtersSize = [];
                        // let filterOffset = 0;
                        // let filtersCanvas = undefined;
                        // if (filtersCanvas) {
                        //     filtersCanvas = await html2canvas(dashboardInfo, { scale: 2 });
                        //     filtersSize = getImageCoordsToFitPage(filtersCanvas, pdfHeight, pdfWidth, pagePadding, 10);
                        //     filterOffset = filtersSize[1] ? filtersSize[1] + 10 : 0;
                        // }

                        // let countByStatistic = document.getElementById('countByStatistic')
                        // if (countByStatistic) {
                        //     if (dashboardInfo) {
                        //         pdf.addImage(filtersCanvas, 'PNG', pagePadding, 10, filtersSize[0], filtersSize[1], undefined, "FAST")
                        //     }
                        //     let metric = await html2canvas(countByStatistic, { scale: 2 })
                        //     const imageSize = getImageCoordsToFitPage(metric, pdfHeight, pdfWidth, pagePadding, filterOffset);
                        //     pdf.addImage(metric, 'PNG', pagePadding + 3.5, filterOffset, imageSize[0], imageSize[1], undefined, "FAST");
                        // }
                        
                        // Array.from(canvases).forEach((el, index) => {
                        //     const imageSize = getImageCoordsToFitPage(el, pdfHeight, pdfWidth, pagePadding, filterOffset)
                        //     if (countByStatistic || index != 0) {
                        //         pdf.addPage({orientation: "landscape"})
                        //     }
                        //     if (filtersCanvas) {
                        //         pdf.addImage(filtersCanvas, 'PNG', pagePadding, 10, filtersSize[0], filtersSize[1], undefined, "FAST")
                        //     }
                        //     pdf.addImage(el, 'PNG', pagePadding, filterOffset, imageSize[0], imageSize[1], undefined, "FAST");
                        // })
                        const currentDate = new Date();
                        pdf.save("Дашборд_" + currentDate.toLocaleDateString("ru") + '.pdf')
                    } catch (error) {console.log(error)}
                    
                    $scope.printablePages = [];
                    $scope.isPrint = false;
                    $scope.isPrintPdf = false;  
                    SpinnerService.stopLoading();
                    $scope.$apply()
                }, 600)
            })
        }

        $scope.isPaging = true;
        $scope.dashboardsCount = 11;
        $scope.pagination = {
            isPaging: $scope.isPaging,
            page: 0,
            size: $scope.isPaging ? 1 : null,
            totalPages: 10,
            totalItems: 10
        };
        $scope.getRealPage = function(page, deps) {
            return page - deps.reduce((acc, red) => acc + red ? 0 : 1, 0);
        }

        $scope.isSetFilters = false;
        $scope.openControlSidebar = $utils.openControlSidebar;
        $scope.toggleFilters = toggleFilters;

        // filter items
        $scope.milestones = [];
        $scope.industries = [];
        $scope.expirationMaintenanceItems = Object.values(ExpirationMaintenance);
        // services
        $scope.filterService = DashboardFiltersService;
        $scope.chartOptionsService = ChartOptionsService;

        let isSidebarFiltersInit = false;
        let isFiltersInit = false;

        $scope.swipeLeft = $event => {
            if ($scope.pagination.isPaging) {
                if ($scope.pagination.page === 0) {
                    $scope.pagination.page = $scope.pagination.totalPages;
                } else {
                    $scope.pagination.page -= 1;
                }
            }
        };
        $scope.swipeRight = $event => {
            if ($scope.pagination.isPaging) {
                if ($scope.pagination.page === $scope.pagination.totalPages) {
                    $scope.pagination.page = 0;
                } else {
                    $scope.pagination.page += 1;
                }
            }
        };

        $scope.$watch(
            () => DashboardFiltersService.getSidebarFilters(),
            () => {
                if (!isSidebarFiltersInit) {
                    isSidebarFiltersInit = true;
                    return;
                }
                $scope.isSetFilters = !angular.equals(
                    DashboardFiltersService.getSidebarFilters(),
                    DashboardFiltersService.getDefaultSidebarFilters(),
                );
                updateMetrics(getFilters());
            },
            true,
        );

        $scope.$watch(
            () => DashboardFiltersService.getFilters(),
            () => {
                if (!isFiltersInit) {
                    isFiltersInit = true;
                    return;
                }
                updateMetrics(getFilters());
            },
            true,
        );

        init();

        function init() {
            initDashboardData();
            loadMilestones();
            loadIndustries();
            updateMetrics(getFilters());
        }

        function initDashboardData() {
            // Диаграмма по требуемым ресурсам
            $scope.requiredResourcesData = [];
            $scope.requiredResourcesLabels = [];
            $scope.requiredResourcesOptions = ChartOptionsService.getPieChartOptions({
                title: 'Требуемые русурсы',
                legendPosition: 'bottom',
            });

            // Диаграмма по отраслевым сферам
            $scope.countByIndustryData = [];
            $scope.countByIndustryLabels = [];
            $scope.countByIndustryOptions = ChartOptionsService.getPieChartOptions({
                title: 'Отраслевая принадлежность',
                legendPosition: 'right',
            });
            $scope.countByIndustryUnit = '';

            // Диаграмма этапов инвестиционных проектов
            $scope.countByPhaseData = [];
            $scope.countByPhaseLabels = [];
            $scope.countByPhaseOptions = ChartOptionsService.getPieChartOptions({
                title: 'Проекты по этапам',
                legendPosition: 'right',
            });

            // Состав инвестиций
            $scope.factFundBySrcCategoryData = [];
            // Задаём лейбл пустой строкой, чтобы в тултипе не выводилось 'undefined'
            $scope.factFundBySrcCategoryLabels = [''];
            $scope.factFundBySrcCategorySeries = [];
            $scope.factFundBySrcCategoryOptions = {};
            $scope.factFundBySrcCategoryUnit = '';

            // Группы рабочих мест
            $scope.workPlaceByGroupData = [];
            // Задаём лейбл пустой строкой, чтобы в тултипе не выводилось 'undefined'
            $scope.workPlaceByGroupLabels = [''];
            $scope.workPlaceByGroupSeries = [];
            $scope.workPlaceByGroupOptions = ChartOptionsService.getPieChartOptions({
                title: 'Группы рабочих мест',
                legendPosition: 'bottom',
            });

            // Состав налоговых поступлений
            $scope.taxData = [];
            $scope.taxLabels = [''];
            $scope.taxSeries = [];
            $scope.taxOptions = {};

            // Ежегодные налоговые поступления
            $scope.taxByQuarterData = [];
            $scope.taxByQuarterLabels = [];
            $scope.taxByQuarterSeries = [];
            $scope.taxByQuarterOptions = {};

            // Территории реализуемых проектов
            $scope.countByMunicipalityRawData = [];
            $scope.countByMunicipalityData = [];
            $scope.countByMunicipalityLabels = ['Количество реализуемых проектов'];
            $scope.countByMunicipalitySeries = [];
            $scope.countByMunicipalityOptions = ChartOptionsService.getHorizontalBarChartOptions({
                title: 'Территории реализуемых проектов',
                xAxeType: 'logarithmic',
                hideLegend: true,
            });

            // Общий объем инвестиций (Фактический)
            $scope.factFundData = [];
            $scope.factFundLabels = ['Объем инвестиций'];
            $scope.factFundSeries = [];
            $scope.factFundOptions = ChartOptionsService.getBarChartOptions({
                title: 'Общий объем инвестиций (Фактический)',
                yAxeType: 'logarithmic',
                hideLegend: true,
            });

            // Общий объем инвестиций (Плановый)
            $scope.planFundData = [];
            $scope.planFundLabels = ['Объем инвестиций'];
            $scope.planFundSeries = [];
            $scope.planFundOptions = ChartOptionsService.getBarChartOptions({
                title: 'Общий объем инвестиций (Плановый)',
                yAxeType: 'logarithmic',
                hideLegend: true,
            });

            // Количество планируемых и созданных рабочих мест
            $scope.workPlaceData = [];
            $scope.workPlaceLabels = ['Количество созданных рабочих мест'];
            $scope.workPlaceSeries = [];
            $scope.workPlaceOptions = ChartOptionsService.getBarChartOptions({
                title: 'Количество созданных рабочих мест',
                yAxeType: 'logarithmic',
                hideLegend: true,
            });

            $scope.countByProjectsManagersData = [];
            $scope.countByProjectsManagersLabels = ['Распределение проектов по менеджерам'];
            $scope.countByProjectsManagersSeries = [];
            $scope.countByProjectsManagersOptions = ChartOptionsService.getHorizontalBarChartOptions({
                title: 'Распределение проектов по менеджерам',
                xAxeType: 'logarithmic',
                hideLegend: true,
            });

            // Классы опасности
            $scope.riskAreaPhazesData = [];
            $scope.riskAreaPhazesLabels = [];
            $scope.riskAreaPhazesSeries = [];
            $scope.riskAreaPhazesOptions = ChartOptionsService.getHorizontalBarChartOptions({
                title: 'Этапы реализации проектов',
                xAxeType: 'logarithmic',
                hideLegend: true,
            });

            $scope.riskAreaZonesData = [];
            $scope.riskAreaZonesLabels = [];
            $scope.riskAreaZonesSeries = [];
            $scope.riskAreaZonesOptions = ChartOptionsService.getHorizontalBarChartOptions({
                title: 'Зоны риска при реализации проектов',
                xAxeType: 'logarithmic',
                hideLegend: true,
            });

            // Требуемые и фактические (предоставленные) ресурсы в разрезе типов ресурсов
            $scope.resourceSupport = [];
            // Для чартов в Статистике
            $scope.summary_fundBySrcCategorySummary = ($scope.summary_fundBySrcCategoryData || []).reduce((acc, red) => acc + (red || 0), 0);
            $scope.summary_fundBySrcCategoryData = [];
            $scope.summary_fundBySrcCategoryUnit = '';
            $scope.summary_fundBySrcCategoryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_fundBySrcCategoryUnit
            })

            $scope.summary_countByIndustrySummary = ($scope.countByIndustryData || []).reduce((acc, red) => acc + (red || 0), 0);
            $scope.summary_countByIndustryUnit = '';
            $scope.summary_countByIndustryLabels = [];
            $scope.summary_countByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_countByIndustryUnit
            });

            $scope.summary_fundByIndustryUnit = '';
            $scope.summary_fundByIndustrySummary = ($scope.fundByIndustryData || []).reduce((acc, red) => acc + (red || 0), 0);
            $scope.summary_fundByIndustryData = [];
            $scope.summary_fundByIndustryLabels = [];
            $scope.summary_fundByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_fundByIndustryUnit
            });

            $scope.summary_projectByOivUnit = '';
            $scope.summary_projectByOivSummary = 0;
            $scope.summary_projectByOivData = [];
            $scope.summary_projectByOivLabels = [];
            $scope.summary_projectByOivOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_projectByOivUnit
            });

            $scope.summary_projectByTypeUnit = '';
            $scope.summary_projectByTypeSummary = 0;
            $scope.summary_projectByTypeData = [];
            $scope.summary_projectByTypeLabels = [];
            $scope.summary_projectByTypeOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_projectByTypeUnit
            });

            $scope.summary_workPlaceByIndustryUnit = '';
            $scope.summary_workPlaceByIndustrySummary = 0;
            $scope.summary_workPlaceByIndustryData = [];
            $scope.summary_workPlaceByIndustryLabels = [];
            $scope.summary_workPlaceByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_workPlaceByIndustryUnit
            });

        }

        function prettyNumericValue(value) {
            return value
              ? value
                  .toLocaleString('ru-RU', { maximumFractionDigits: 2 })
                  .replace(',', '.')
              : 0;
          }

        function loadMilestones() {
            MilestoneService.api.get({ sorts: ['npp:ASC', 'name:ASC'] })
                .$promise
                .then(data => {
                    $scope.milestones = [angular.copy($filterUtils.defaultEmptySelectorElement())].concat(data._embedded);
                });
        }

        function loadIndustries() {
            IndustryService.api.get({
                filters: [`'status' EQ 'ENABLED'`],
                sorts: ['npp:ASC', 'name:ASC'],
            })
                .$promise
                .then(data => {
                    $scope.industries = [{
                        id: "none",
                        name: 'Не указано',
                    }].concat(data._embedded)
                });
        }

        function toggleFilters() {
            if (angular.equals(
                DashboardFiltersService.getSidebarFilters(),
                DashboardFiltersService.getDefaultSidebarFilters(),
            )) {
                $scope.isSetFilters = false;
                return;
            }
            updateMetrics(getFilters());
        }


        function getFilters() {
            return DashboardFiltersService.collectFilterDto(
                $scope.isSetFilters
                    ? DashboardFiltersService.getAllFilters()
                    : DashboardFiltersService.getFilters(),
            );
        }

        async function updateMetrics(filterDto) {
            SpinnerService.startLoading();

            let [
                countByIndustry,
                countByPhase,
                factFundBySrcCategory,
                workPlaceByGroup,
                //tax,
                taxByQuarter,
                fundsByMunicipality,
                planFund,
                factFundQuarter,
                workPlaceQuarter,
                projectsByManagersData,
                statisticData,
                riskAreaData,
                fundByIndustry,
                projectByOiv,
                projectByType,
                workPlaceByIndustry,
            ] = await $q.all([
                MetricService.countByIndustry(filterDto),
                MetricService.countByPhase(filterDto),
                MetricService.factFundBySrcCategory(filterDto),
                MetricService.workPlaceByGroup(filterDto),
                //MetricService.tax(filterDto),
                MetricService.taxByQuarter(filterDto),
                MetricService.fundsByMunicipality(),
                MetricService.planFundByQuarter(filterDto),
                MetricService.factFundByQuarter(filterDto),
                MetricService.workPlaceByQuarter(filterDto),
                MetricService.projectsByManagers(filterDto),
                ProjectService.api.getStatistic({
                    filters: getStatisticFilters(),
                    searchs: null,
                    sorts: ['code:DESC', 'shortName:ASC', 'name:ASC'],
                    page: 1,
                    size: null,
                }).$promise,
                MetricService.projectsByRisk(filterDto),
                MetricService.fundByIndustry(filterDto),
                MetricService.projectByOiv(filterDto),
                MetricService.projectByType(filterDto),
                MetricService.workPlaceByIndustry(filterDto),
            ]);
            // Данные для статистики
            $scope.statistic = statisticData._embedded;
            $scope.statistic.totalCost = (statisticData._embedded.totalCost / 1000).toFixed(2);

            // Диаграмма по отраслевым сферам
            parseCountByIndustryChartData(countByIndustry);
            // Диаграмма этапов инвестиционных проектов
            parseCountByPhaseChartData(countByPhase);
            // Состав инвестиций
            parseFactFundBySrcCategoryChartData(factFundBySrcCategory);
            // Группы рабочих мест
            parseWorkPlaceByGroupChartData(workPlaceByGroup);
            // Состав налоговых поступлений
            //parseTaxChartData(tax);
            // Ежегодные налоговые поступления
            parseTaxByQuarterChartData(taxByQuarter);
            // Территории реализуемых проектов
            parseCountByMunicipalityChartData(fundsByMunicipality);
            // Общий объем инвестиций (Фактический)
            parseFactFundChartData(planFund, factFundQuarter);
            // Общий объем инвестиций (Плановый)
            //parsePlanFundChartData(planFund);
            // Количество планируемых и созданных рабочих мест
            parseWorkplaceChartData(workPlaceQuarter);
            // Распределение проектов по менеджерам
            parseCountByProjectsMaragersChartData(projectsByManagersData)
            // Проекты по зонам риска
            parseRiskAreaChartData(riskAreaData)
            // Инвестиции по отраслям
            parseFundByIndustryChartData(fundByIndustry)
            // Инвестиции по ОИВ
            parseProjectByOivChartData(projectByOiv)
            // Инвестиции по типам
            parseProjectByTypeChartData(projectByType)
            // Распределение рабочих мест по отраслям
            parseWorkPlaceByIndustryChartData(workPlaceByIndustry)

            // ProjectService.api.getAll({
            //     sorts: ['code:DESC', 'shortName:ASC', 'name:ASC'],
            // }, function(data) {
            //     console.log(data._);
            //     console.log(angular.copy(data._embedded));
            // });

            SpinnerService.stopLoading();

            $scope.$apply();
        }

        function parseFundByIndustryChartData(fundByIndustry) {
            $scope.summary_fundByIndustryData = getDataOrEmptyData($utils.mapArray(fundByIndustry, $utils.getObjectValueField));
            $scope.summary_fundByIndustryLabels = $utils.mapArray(fundByIndustry, $utils.getObjectNameField);
            $scope.summary_fundByIndustryUnit = fundByIndustry[0] ? fundByIndustry[0].unit : '';
            $scope.summary_fundByIndustrySummary = prettyNumericValue(($scope.summary_fundByIndustryData || []).reduce((acc, red) => acc + (red || 0), 0));
            $scope.summary_fundByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_countByIndustryUnit
            });
        }

        function parseProjectByOivChartData(projectByOiv) {
            $scope.summary_projectByOivData = getDataOrEmptyData($utils.mapArray(projectByOiv, $utils.getObjectValueField));
            $scope.summary_projectByOivLabels = $utils.mapArray(projectByOiv, $utils.getObjectNameField);
            $scope.summary_projectByOivUnit = projectByOiv[0] ? projectByOiv[0].unit : '';
            $scope.summary_projectByOivSummary = prettyNumericValue(($scope.summary_projectByOivData || []).reduce((acc, red) => acc + (red || 0), 0));
            $scope.summary_projectByOivOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_projectByOivUnit
            });
        }

        function parseProjectByTypeChartData(projectByType) {
            $scope.summary_projectByTypeData = getDataOrEmptyData($utils.mapArray(projectByType, $utils.getObjectValueField));
            $scope.summary_projectByTypeLabels = $utils.mapArray(projectByType, $utils.getObjectNameField);
            $scope.summary_projectByTypeUnit = projectByType[0] ? projectByType[0].unit : '';
            $scope.summary_projectByTypeSummary = projectByType.map(item => item.value).reduce((acc, red) => acc + (red || 0), 0);
            $scope.summary_projectByTypeOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_projectByTypeUnit
            });
        }

        function parseWorkPlaceByIndustryChartData(workPlaceByIndustry) {
            $scope.summary_workPlaceByIndustryData = getDataOrEmptyData($utils.mapArray(workPlaceByIndustry, $utils.getObjectValueField));
            $scope.summary_workPlaceByIndustryLabels = $utils.mapArray(workPlaceByIndustry, $utils.getObjectNameField);
            $scope.summary_workPlaceByIndustryUnit = workPlaceByIndustry[0] ? workPlaceByIndustry[0].unit : '';
            $scope.summary_workPlaceByIndustrySummary = prettyNumericValue(($scope.summary_workPlaceByIndustryData || []).reduce((acc, red) => acc + (red || 0), 0));
            $scope.summary_workPlaceByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_workPlaceByIndustryUnit
            });
        }

        function parseRiskAreaChartData(projectsByRisk) {
            const projectsByRiskPhazes = (projectsByRisk.phazes || []).sort((a,b) => a.order - b.order)
            const projectsByRiskZones = (projectsByRisk.zones || []).sort((a,b) => a.order - b.order)

            $scope.riskAreaPhazesData = getDataOrEmptyData($utils.mapArray(projectsByRiskPhazes, (item) => [item.count]));
            $scope.riskAreaPhazesLabels = [];
            $scope.riskAreaPhazesSeries = projectsByRiskPhazes.map(item => item.name);
            $scope.riskAreaPhazesOptions = ChartOptionsService.getRiskAreaBarOptions({
                title: 'Этапы реализации проектов',  
                hideLegend: true,
                stackXAxe: true,
                stackYAxe: true,
                xAxeRemove: false,
                yAxeRemove: true,
                maxXValue: $scope.riskAreaPhazesData.reduce((acc, red) => acc + (red[0] || 0), 0),
                tooltipsData: projectsByRiskPhazes.map(n => ({
                    title: n.name,
                    beforeLabel: n.count + " проектов",
                    label: n.financies + " млн. рублей",
                    afterLabel: n.workplaces + " рабочих мест",
                })),
                unit: 'шт.',
            });

            $scope.riskAreaZonesData = getDataOrEmptyData($utils.mapArray(projectsByRiskZones, (item) => [item.count]));
            $scope.riskAreaZonesLabels = [];
            $scope.riskAreaZonesSeries = projectsByRiskZones.map(item => item.name);
            $scope.riskAreaZonesOptions = ChartOptionsService.getRiskAreaBarOptions({
                title: 'Зоны риска при реализации проектов',
                hideLegend: true,
                stackXAxe: true,
                stackYAxe: true,
                xAxeRemove: false,
                yAxeRemove: true,
                maxXValue: $scope.riskAreaZonesData.reduce((acc, red) => acc + (red[0] || 0), 0),
                tooltipsData: projectsByRiskZones.map(n => ({
                    title: n.name,
                    beforeLabel: n.count + " проектов",
                    label: n.financies + " млн. рублей",
                    afterLabel: n.workplaces + " рабочих мест",
                })),
                unit: 'шт.',
            });

            console.log($scope.riskAreaPhazesData, $scope.riskAreaPhazesLabels, $scope.riskAreaPhazesSeries)
        }

        function parseCountByIndustryChartData(countByIndustry) {
            $scope.countByIndustryData = getDataOrEmptyData($utils.mapArray(countByIndustry, $utils.getObjectValueField));
            $scope.countByIndustryLabels = $utils.mapArray(countByIndustry, $utils.getObjectNameField);
            $scope.summary_countByIndustryUnit =  countByIndustry[0] ? countByIndustry[0].unit : '';
            $scope.summary_countByIndustryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_countByIndustryUnit
            });
            $scope.summary_countByIndustrySummary = prettyNumericValue(($scope.countByIndustryData || []).reduce((acc, red) => acc + (red || 0), 0));
        }

        function parseCountByPhaseChartData(countByPhase) {
            $scope.countByPhaseData = getDataOrEmptyData($utils.mapArray(countByPhase, $utils.getObjectValueField));
            $scope.countByPhaseLabels = $utils.mapArray(countByPhase, $utils.getObjectNameField);
        }

        function parseFactFundBySrcCategoryChartData(factFundBySrcCategory) {
            factFundBySrcCategory = factFundBySrcCategory.sort((a, b) => a.value - b.value);

            $scope.factFundBySrcCategoryData = getDataOrEmptyData(
                $utils.mapArray(factFundBySrcCategory, $utils.getObjectValueField)
                    .map(value => [value]),
            );
            $scope.factFundBySrcCategorySeries = $utils.mapArray(factFundBySrcCategory, $utils.getObjectNameField);
            $scope.factFundBySrcCategoryOptions = ChartOptionsService.getBarChartOptions({
                hideLegend: !$scope.factFundBySrcCategorySeries.length,
                minYValue: 0,
                xAxeBarPercentage: 0.5,
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                xAxeCategoryPercentage: 0.9,
                unit: !!factFundBySrcCategory[0]
                    ? factFundBySrcCategory[0].unit
                    : null,
                title: !!factFundBySrcCategory[0]
                    ? `Структура инвестиций (${factFundBySrcCategory[0].unit.replace('.', '')})`
                    : 'Структура инвестиций',
            });

            $scope.summary_fundBySrcCategoryData = getDataOrEmptyData(
                $utils.mapArray(factFundBySrcCategory, $utils.getObjectValueField)),
            $scope.summary_fundBySrcCategoryUnit = factFundBySrcCategory[0] ? factFundBySrcCategory[0].unit.replace('.', '') : '';
            $scope.summary_fundBySrcCategoryOptions = ChartOptionsService.getDoghnutChartOptions({
                hideLegend: true,
                hideLabels: true,
                unit: $scope.summary_fundBySrcCategoryUnit
            })
            $scope.summary_fundBySrcCategorySummary = prettyNumericValue(($scope.summary_fundBySrcCategoryData || []).reduce((acc, red) => acc + (red || 0), 0));
        }

        function parseWorkPlaceByGroupChartData(workPlaceByGroup) {
            $scope.workPlaceByGroupData = getDataOrEmptyData(
                $utils.mapArray(workPlaceByGroup, $utils.getObjectValueField)
                    .map(value => [value]),
            );
            $scope.workPlaceByGroupSeries = $utils.mapArray(workPlaceByGroup, $utils.getObjectNameField);
        }

        function parseTaxChartData(tax) {
            tax = tax.sort((a, b) => a.value - b.value);

            $scope.taxData = getDataOrEmptyData(
                $utils.mapArray(tax, $utils.getObjectValueField)
                    .map(value => [value]),
            );
            $scope.taxSeries = $utils.mapArray(tax, $utils.getObjectNameField);
            $scope.taxOptions = ChartOptionsService.getBarChartOptions({
                hideLegend: !$scope.taxSeries.length,
                minYValue: 0,
                xAxeBarPercentage: 0.5,
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                xAxeCategoryPercentage: 1,
                unit: !!tax[0]
                    ? tax[0].unit
                    : null,
                title: !!tax[0]
                    ? `Состав налоговых поступлений (${tax[0].unit})`
                    : 'Состав налоговых поступлений',
            });
        }

        function parseRequiredResourcesChartData(requiredResources) {
            $scope.requiredResourcesData = [
                getDataOrEmptyData(
                    requiredResources.map(item => item.current),
                ),
                getDataOrEmptyData(
                    requiredResources.map(item => item.expected),
                )
            ]
            $scope.requiredResourcesSeries = ['Факт', 'План'];
            $scope.requiredResourcesLabels = requiredResources.map(item => item.name);
            $scope.requiredResourcesOptions = ChartOptionsService.getBarChartOptions({
                title: 'Требуемые русурсы',
                legendPosition: 'bottom',
                yAxeType: 'logarithmic',
                defaultTooltip: true
            });
        }

        function parseTaxByQuarterChartData(taxByQuarter) {          

            let taxByQuarterYears = getDataOrEmptyData(
                taxByQuarter.map(tax => tax.year)
                    .sort((a, b) => a - b)
                    .filter((year, index, array) => index === array.indexOf(year)),
            );

            $scope.taxByQuarterData = [
                getDataOrEmptyData(
                    taxByQuarterYears
                        .map(
                            year => taxByQuarter
                                .filter(tax => tax.year === year)
                                .map(tax => tax.fedValue)
                                .reduce((acc, red) => acc + red, 0),
                        ),
                ).map(value => value / 10**6),
                getDataOrEmptyData(
                    taxByQuarterYears
                        .map(
                            year => taxByQuarter
                                .filter(tax => tax.year === year)
                                .map(tax => tax.regValue)
                                .reduce((acc, red) => acc + red, 0),
                        ),
                ).map(value => value / 10**6),
            ];

            $scope.taxByQuarterLabels = taxByQuarterYears.map(year => `${year} год`);
            $scope.taxByQuarterSeries = ['Федеральные поступления', 'Региональные поступления'];
            $scope.taxByQuarterOptions = ChartOptionsService.getBarChartOptions({
                title: !!taxByQuarter[0]
                    ? `Планируемые налоговые поступления (млн ${taxByQuarter[0].unit})`
                    : 'Планируемые налоговые поступления',
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                unit: !!taxByQuarter[0]
                    ? `млн ${taxByQuarter[0].unit}`
                    : null,
            });
        }

        function parseCountByMunicipalityChartData(countByMunicipality) {
            // const halfArrayLength = Math.ceil(countByMunicipality.length / 2);
            // const countByMunicipalityData = countByMunicipality.map(metric => metric.value);
            // const countByMunicipalityLabels = countByMunicipality.map(metric => metric.name);
            // $scope.countByMunicipalityData = countByMunicipality.length
            //     ? countByMunicipality.length > 25 
            //         ? [[countByMunicipalityData.slice(0, halfArrayLength)], [countByMunicipalityData.slice(halfArrayLength)]]
            //         : [[countByMunicipalityData]]
            //     : [[[0]]];
            // $scope.countByMunicipalityLabels =
            //     countByMunicipality.length > 25 
            //         ? [countByMunicipalityLabels.slice(0, halfArrayLength), countByMunicipalityLabels.slice(halfArrayLength)]
            //         : [countByMunicipalityLabels]
            // $scope.countByMunicipalitySeries = ['Количество реализуемых проектов'];

            // $scope.countByMunicipalityOptions = ChartOptionsService.getHorizontalBarChartOptions({
            //     title: 'Количество реализуемых проектов',
            //     xAxeType: 'logarithmic',
            //     hideLegend: true,
            //     unit: !!countByMunicipality[0]
            //         ? `${countByMunicipality[0].unit}`
            //         : null,
            // });

            $scope.countByMunicipalityRawData = countByMunicipality;
        }

        function parseCountByProjectsMaragersChartData(countByProjectsManagers) {

            const halfArrayLength = Math.ceil(countByProjectsManagers.length / 2);
            const countByProjectsManagersData = countByProjectsManagers.map(metric => metric.value);
            const countByProjectsManagersLabels = countByProjectsManagers.map(metric => metric.name);
            $scope.countByProjectsManagersData = countByProjectsManagers.length
                ? countByProjectsManagers.length > 25 
                    ? [[countByProjectsManagersData.slice(0, halfArrayLength)], [countByProjectsManagersData.slice(halfArrayLength)]]
                    : [[countByProjectsManagersData]]
                
                : [[[0]]];
            $scope.countByProjectsManagersLabels =
                countByProjectsManagers.length > 25 
                    ? [countByProjectsManagersLabels.slice(0, halfArrayLength), countByProjectsManagersLabels.slice(halfArrayLength)]
                    : [countByProjectsManagersLabels]
            $scope.countByProjectsManagersSeries = ['Распределение проектов по менеджерам'];

            $scope.countByProjectsManagersOptions = ChartOptionsService.getHorizontalBarChartOptions({
                title: 'Распределение проектов по менеджерам',
                xAxeType: 'logarithmic',
                hideLegend: true,
                unit: !!countByProjectsManagers[0]
                    ? `${countByProjectsManagers[0].unit}`
                    : null,
            });
        }

        function parseFactFundChartData(planFund, factFund) {
            let factFundYears = getDataOrEmptyData(
                [...factFund.map(tax => tax.year), ...planFund.map(tax => tax.year)]
                    .sort((a, b) => a - b)
                    .filter((year, index, array) => index === array.indexOf(year)),
            );

            $scope.factFundData = [
                getDataOrEmptyData(
                    factFundYears
                        .map(
                            year => {
                                let fund = planFund.find(tax => tax.year === year);
                                return fund ? fund.value : 0;
                            }
                        ),
                ),
                getDataOrEmptyData(
                    factFundYears
                        .map(
                            year => {
                                let fund = factFund.find(tax => tax.year === year);
                                return fund ? fund.value : 0;
                            }
                        ),
                )
            ];
            $scope.factFundLabels = factFundYears.map(fund => `${fund} год`);
            $scope.factFundSeries = ['План', 'Факт'];
            $scope.factFundOptions = ChartOptionsService.getBarChartOptions({
                title: factFund[0]
                    ? `Общий объем инвестиций (${factFund[0].unit.replace('.', '')})`
                    : 'Общий объем инвестиций',
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                unit: !!factFund[0]
                    ? factFund[0].unit
                    : null,
            });
        }

        function parsePlanFundChartData(planFund) {
            $scope.planFundData = planFund
                ? [[0, 0, 0, 0]]
                : [0];
            $scope.planFundLabels = [2018,2019,2020,2021].map(fund => `${fund} год`);
            $scope.planFundSeries = ['Объем инвестиций'];
            $scope.planFundOptions = ChartOptionsService.getBarChartOptions({
                title: planFund[0]
                    ? `Общий объем инвестиций (Плановый) (${planFund.unit})`
                    : 'Общий объем инвестиций (Плановый)',
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                hideLegend: true,
                unit: !!planFund
                    ? planFund.unit
                    : null,
            });
        }

        function parseWorkplaceChartData(workplaceByQuarter) {
            let workplaceByQuarterYears = getDataOrEmptyData(
                workplaceByQuarter.map(workplace => workplace.year)
                    .sort((a, b) => a - b)
                    .filter((year, index, array) => index === array.indexOf(year)),
            );

            let workplaceByQuarterQuarters = Array(4)
                .fill({})
                .map((_item, index) => index + 1);

            workplaceByQuarterYears.forEach(year => {
                workplaceByQuarterQuarters.forEach(quarter => {
                    const current = workplaceByQuarter.find(
                        workplace => workplace.year === year && workplace.quarter === quarter
                    );
                    if (!current) {
                        workplaceByQuarter.push({
                            value: 0,
                            unit: !!workplaceByQuarter[0] ? workplaceByQuarter[0].unit : '',
                            year: year,
                            quarter: quarter,
                        })
                    }
                })
            });

            workplaceByQuarter = workplaceByQuarter.sort((a, b) => a.value - b.value);

            $scope.workplaceData = getDataOrEmptyData(
                workplaceByQuarterQuarters
                    .map(
                        quarter => workplaceByQuarter
                            .filter(workplace => workplace.quarter === quarter)
                            .sort((a, b) => a.year - b.year)
                            .map(workplace => workplace.value),
                    ),
            );

            $scope.workplaceLabels = workplaceByQuarterYears;
            $scope.workplaceSeries = Array(4)
                .fill({})
                .map((_item, index) => `${index + 1} квартал`);
            $scope.workplaceOptions = ChartOptionsService.getBarChartOptions({
                title: !!workplaceByQuarter[0]
                    ? `Количество созданных рабочих мест (${workplaceByQuarter[0].unit})`
                    : 'Количество созданных рабочих мест',
                yAxeType: 'logarithmic',
                legendPosition: 'bottom',
                unit: !!workplaceByQuarter[0]
                    ? workplaceByQuarter[0].unit
                    : null,
            });
        }

        function getDataOrEmptyData(dataArray) {
            return dataArray.length
                ? dataArray
                : [0];
        }

        function getStatisticFilters() {
            let filters = [];
            filters.push(`'entityStatus' EQ 'ENABLED'`);
            if (!$scope.filters || !$scope.localFilters) {
                return filters;
            }

            if (Array.isArray($scope.filters.industry) && $scope.filters.industry.length) {
                filters.push(`EXTRA:'industry' EQ '${$scope.filters.industry.map(n => "" + n.id).join(';')}'`);
            }

            if (!!$scope.filters.milestone) {
                filters.push(`EXTRA:'milestone' EQ '${$scope.filters.milestone}'`);
            }

            if ($scope.localFilters.area != null && $scope.localFilters.area.id != null) {
                filters.push(`'area.id' EQ '${$scope.localFilters.area.id}'`);
            }
            if (Array.isArray($scope.localFilters.placeMunicipality) && $scope.localFilters.placeMunicipality.length) {
                filters.push(`EXTRA:'placesMunicipality' EQ '${$scope.localFilters.placeMunicipality.map(n => "" + n.id).join(';')}'`);
            }

            if (Array.isArray($scope.localFilters.phase) && $scope.localFilters.phase.length) {
                filters.push(`EXTRA:'phase' EQ '${$scope.localFilters.phase.map(n => "" + n.id).join(';')}'`);
            }

            if ($scope.localFilters.planFundsTotal1 != null) {
                if ($scope.isBetween($scope.localFilters.operatorPlanFundsTotal)) {
                    filters.push(`'planFundsTotal' GE '${$scope.localFilters.planFundsTotal1}'`);
                    if ($scope.localFilters.planFundsTotal2 != null) {
                        filters.push(`'planFundsTotal' LE '${$scope.localFilters.planFundsTotal2}'`);
                    }
                } else {
                    filters.push(`'planFundsTotal' ${$scope.localFilters.operatorPlanFundsTotal} '${$scope.localFilters.planFundsTotal1}'`);
                }
            }

            if ($scope.localFilters.profitPlanWplaces1 != null) {
                if ($scope.isBetween($scope.localFilters.operatorProfitPlanWplaces)) {
                    filters.push(`'profitPlanWplaces' GE '${$scope.localFilters.profitPlanWplaces1}'`);
                    if ($scope.localFilters.profitPlanWplaces2 != null) {
                        filters.push(`'profitPlanWplaces' LE '${$scope.localFilters.profitPlanWplaces2}'`);
                    }
                } else {
                    filters.push(`'profitPlanWplaces' ${$scope.localFilters.operatorProfitPlanWplaces} '${$scope.localFilters.profitPlanWplaces1}'`);
                }
            }
        
            return filters;
        }

        // $scope.$watch("countByMunicipalityData[1]", (newValue, oldValue) => {
        //     if (newValue && !oldValue && $scope.pagination.totalPages < 10) {
        //         $scope.pagination.totalPages += 1;
        //     }
        //     if ((!newValue && oldValue)) {
        //         $scope.pagination.totalPages -= 1;
        //         $scope.pagination.page = Math.min($scope.pagination.page, $scope.pagination.totalPages)
        //     }
        // })
        $scope.$watch("countByProjectsManagersData[1]", (newValue, oldValue) => {
            if (newValue && !oldValue && $scope.pagination.totalPages < $scope.dashboardsCount) {
                $scope.pagination.totalPages += 1;
            }
            if ((!newValue && oldValue)) {
                $scope.pagination.totalPages -= 1;
                $scope.pagination.page = Math.min($scope.pagination.page, $scope.pagination.totalPages)
            }
        })
    }];
